/**
 * Semantic Animation Tokens — CSS variable references and transitions.
 */

import { durationValues, easing } from "../primitives/animation";

export const duration = {
  fast: "var(--dur-fast)",
  base: "var(--dur-base)",
  slow: "var(--dur-slow)",
} as const;

export const transition = {
  fast: `${durationValues.fast} ${easing.default}`,
  base: `${durationValues.base} ${easing.default}`,
  slow: `${durationValues.slow} ${easing.default}`,
} as const;
